import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-87edfd7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-button__text" }

import { useStore } from 'vuex';
import InfoCircleIcon from "../../icons/InfoCircle.vue";

interface Props {
	modalName: string;
	label: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OpenButton',
  props: {
    modalName: {},
    label: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();

function showInfoModal() {
	store.commit('updateCurrentModalName', props.modalName);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "info-button",
    type: "button",
    onClick: showInfoModal
  }, [
    _createVNode(InfoCircleIcon),
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.label), 1)
  ]))
}
}

})